import { useState } from 'react';
import I18n from 'i18n-js';

import { Expandable } from '~/components/atoms/Expandable';
import ButtonClean from '~/components/ButtonClean';
import {
  EPlatform,
  PlatformButton,
} from '~/components/molecules/PlatformButton';

import styles from './SocialLogins.module.scss';

export function SocialLogins({
  onProviderClick,
}: {
  onProviderClick: (provider: EPlatform) => void;
}): JSX.Element {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <h5 className={styles.socialLogins}>{I18n.t('MenuView_login_other')}</h5>
      <PlatformButton
        platform={EPlatform.FACEBOOK}
        onProviderClick={onProviderClick}
      />
      <PlatformButton
        platform={EPlatform.GOOGLE}
        onProviderClick={onProviderClick}
      />
      <PlatformButton
        platform={EPlatform.APPLE}
        onProviderClick={onProviderClick}
      />
      <Expandable isExpanded={showMore}>
        <PlatformButton
          platform={EPlatform.TWITCH}
          onProviderClick={onProviderClick}
        />
        <PlatformButton
          platform={EPlatform.STEAM}
          onProviderClick={onProviderClick}
        />
      </Expandable>
      <ButtonClean
        onClick={() => {
          setShowMore((prev) => !prev);
        }}
        className={styles.socialLoginsExpander}
      >
        {showMore ? I18n.t('common_show_less') : I18n.t('common_show_more')}
      </ButtonClean>
    </>
  );
}
